import Big from 'big.js';
import dayjs from 'dayjs';
import { formatNumber } from './amountUtils';

export function getGiftImage(gift, type, variant = 'original') {
  const image = gift.images?.find(img => img.type === type);
  if (image) {
    if (variant === 'original') {
      return `${image?.baseURL}/${image?.imageVariants?.[variant]}`;
    } else {
      return `${image?.baseURL}/${image?.imageVariants?.variants?.[variant]}`;
    }
  }

  return null;
}

export function getGiftName(gift) {
  return gift?.name || '';
}

export function getCharacteristics(giftDetails) {
  let list = [];
  giftDetails.contentGroups.map(group => {
    let title = group.title;
    let texts = group?.items?.[0]?.description?.split('\n');
    list.push({ title, texts });
  });
  return list;
}
export function isProgressBarVisible(remainingPoints, progressBarThreshold) {
  const result = remainingPoints > 0 && (!progressBarThreshold || remainingPoints <= progressBarThreshold);

  return result;
}

export function transformGift(gift, userPoints, t, progressBarThreshold = null) {
  if (!gift || !process) return;

  const remainingPoints =
    gift.redemptionPoints > userPoints ? new Big(gift.redemptionPoints).minus(userPoints).toNumber() : 0;
  const showUserPoints = gift.redemptionPoints > userPoints;

  const showProgressBar = isProgressBarVisible(remainingPoints, progressBarThreshold);
  const newGift = {
    id: gift._id,
    displayName: getGiftName(gift),
    image: getGiftImage(gift, 'PRIMARY'),
    brandImage: getGiftImage(gift, 'BRAND'),
    available: gift.available && gift.redemptionPoints <= userPoints,
    tileSize: process.env.tileSize,
    slug: gift.slug ?? gift._id,
    userPoints: showUserPoints ? formatNumber(userPoints) : null,
    giftPoints: formatNumber(gift?.redemptionPoints),
    pointsText: t('gifts.points'),
    buttonText: t('gifts.redeem'),
    informativeText: showProgressBar ? `${remainingPoints} ${t('gifts.informative_text')}` : '',
    progress: showProgressBar
      ? //added Math.min to prevent bar to appear full
        Math.min(96, new Big(userPoints).div(gift.redemptionPoints).times(100).toNumber())
      : null,
    sku: gift.sku,
    showProgressBar,
  };

  return newGift;
}

export function transformGiftFromDetails(giftDetails) {
  if (!giftDetails) return {};
  const additionalGiftFields = {
    description: giftDetails?.description,
    characteristics: getCharacteristics(giftDetails),
  };

  return additionalGiftFields;
}

export const getGiftReceiptDetails = (response, t, timeFormat) => {
  const list = [
    { label: t('gifts.receipt.user_name'), text: `${response?.user?.firstName} ${response?.user?.lastName}` },
    { label: t('gifts.receipt.code'), text: response?.friendlyId },
    { label: t('gifts.receipt.points'), text: response?.totalRedemptionPoints },
    {
      label: t('gifts.receipt.date_time'),
      text: response?.createdAt ? dayjs(response?.createdAt).format(`${process.env.dateFormat} ${timeFormat}`) : '',
    },
  ];
  return list;
};
